module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0092.jpg?v=3017860c";